import { isObject, has, isEqual, pick } from "lodash-es";

export default ({ app, store, route, redirect, localePath }, inject) => {
  const broadcastChannel = new BroadcastChannel("broadcastChannel");
  const queuePriorityByType = {
    AUTH: 900,
    NOTIFICATION: 800,
  };
  const queue = [];

  const pickCart = (obj) => {
    return pick(obj, [
      "unique_id",
      "contact_email",
      "shipping_rates",
      "shipping_address",
      "billing_address",
      "gift_card",
      "discount",
      "items",
      "options",
    ]);
  };

  const addToQueue = (event) => {
    const { type } = event;

    const existingIndex = queue.findIndex((item) => item.type === type);

    if (existingIndex !== -1) {
      queue[existingIndex] = {
        type,
        priority: queuePriorityByType[type] || 0,
        event,
      };
    } else {
      queue.push({ type, priority: queuePriorityByType[type] || 0, event });
    }

    queue.sort((a, b) => b.priority - a.priority);
  };

  const processQueue = async () => {
    for (const item of queue) {
      try {
        switch (item.type) {
          case "AUTH": {
            document.body.setAttribute("inert", "");
            document.location.reload();
            return;
          }
          case "UPDATE_CART": {
            if (
              !isEqual(
                pickCart(item.event.data?.cart),
                pickCart(store.getters["cart/getRegularCartInfo"])
              )
            ) {
              await store.dispatch("getCart");
            }

            break;
          }
          case "UPDATE_CHECKOUT_CART": {
            const cartId =
              item.event.data?.cart?.unique_id ||
              item.event.data?.old_unique_id;
            if (
              !isEqual(
                pickCart(item.event.data),
                pickCart(store.getters["cart/getCheckoutCartInfo"])
              ) &&
              route.path.includes("checkout") &&
              cartId === store.getters["cart/getCheckoutCartInfo"]?.unique_id
            ) {
              store.commit("cart/SET_GLOBAL_CHECKOUT_LOADER", true);
              if (!item.event.data?.cart && item.event.data?.old_unique_id) {
                await store.dispatch("cart/setCheckoutCartInfo", null);
              } else if (item.event.data?.cart) {
                await store.dispatch(
                  "cart/setCheckoutCartInfo",
                  item.event.data?.cart
                );
              }
              store.commit("cart/SET_GLOBAL_CHECKOUT_LOADER", false);
            }
            break;
          }
          default: {
            console.warn("Unhandled event type:", item.type);
          }
        }
      } catch (error) {
        console.error(`Error processing event of type ${item.type}:`, error);
      }
    }
    queue.length = 0;
  };

  document.addEventListener("visibilitychange", async () => {
    if (document.visibilityState === "visible" && queue.length > 0) {
      await processQueue();
    }
  });

  broadcastChannel.onmessage = async (event) => {
    if (isObject(event.data) && has(event.data, "type")) {
      addToQueue(event.data);

      if (document.visibilityState === "visible") {
        await processQueue();
      }
    }
  };

  inject("broadcastChannel", broadcastChannel);
};
